<template>
  <div id="invitation">
    <van-row>
      <van-col span="24">
        <van-list
          v-model="show"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('other.there_is_no_more')"
          @load="onLoad"
          :offset="10"
        >
          <van-cell v-for="t in list" :key="t.id">
            <van-col span="24" class="invitatiion_subordinate_vue_type" @click="Invite_earnings(t.id)">
              <van-col span="5" class="invitatiion_subordinate_vue_type_img">
                <img :src="t.head_image"/>
              </van-col>
              <van-col span="17" class="invitatiion_subordinate_vue_name">
                <van-col span="24" class="invitatiion_subordinate_vue_name1">{{ t.nick_name }}</van-col>
                <van-col span="24" class="invitatiion_subordinate_vue_name2">{{ $t('other.profit')}} ：{{ t.coin }}{{ $t('other.yuan')}}</van-col>
              </van-col>
              <van-col span="2" class="invitatiion_subordinate_vue_icon"><van-icon name="arrow" /></van-col>
            </van-col>
          </van-cell>
        </van-list>
        <van-col span="24" v-if="is_show" class="no_val">
          <van-icon name="underway-o" /> &nbsp;&nbsp;&nbsp;{{ $t('other.no_record')}}
        </van-col>
      </van-col>
      <van-col span="24" class="iphonex_bottom"></van-col>
    </van-row>

  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  export default {
    data() {
      return {
        list: [],
        show: false,
        finished: false,
        page: 1,
        page_size: 0,
        is_show: false
      }
    },
    created: function() {
      this.page = 1
      this.list = []
      this.convert()
      document.title = this.$t('title.invitation')
    },
    methods: {
      convert: function() {
        const token = this.$route.query.token
        const type = this.$route.query.type
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=subordinate", {
          params : {
            token: token,
            type: type,
            page: this.page
          }
        }).then(res =>{
          console.log(res.data)
          for (let j=0; j<res.data.data.list.length; j++ ){
            this.list.push(res.data.data.list[j])
          }
          if (this.page === 1) {
            document.title = res.data.data.name
            this.page_size = res.data.data.page_size
          }
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (res.data.data.list.length < this.page_size) {
            if (this.page === 1 && res.data.data.list.length === 0) {
              this.is_show = true
            } else if(this.page !== 1) {
              this.finished = true
            }
          }
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }
          this.show = false
        })
      },
      onLoad() {
        this.page++
        this.convert()
      },
      Invite_earnings (id) {
        const token = this.$route.query.token
        this.$router.push({path:'/invitationEarnings',query:{token: token, type:this.type, consumers:id }});
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/invitation_subordinate.vue